const data = [
  {
    name: "Início",
    path: null,
    children: [
      { name: "Dashboard", icon: "mdi-view-dashboard-outline", route: "/home", path: null },
    ],
  },
  {
    name: "Gestão",
    path: "Manager",
    children: [
      { name: "Administradores", icon: "mdi-account-supervisor-circle-outline", route: "/admins", path: "Admin" },
      { name: "Cargos e permissões", icon: "mdi-shield-account-outline", route: "/cargos", path: "Role" },
      { name: "Alunos", icon: "mdi-account-school-outline", route: "/alunos", path: "Student" },
      { name: "Colaboradores", icon: "mdi-account-multiple-outline", route: "/colaboradores", path: "Employee" },
      { name: "Visitantes", icon: "mdi-account-clock-outline", route: "/visitantes", path: "Guest" },
      { name: "Responsáveis", icon: "mdi-human-male-boy", route: "/responsaveis", path: "Answerable" },
      { name: "Transportes Escolares", icon: "mdi-bus-school", route: "/transportes-escolares", path: "SchoolTransporter" },
      { name: "Equipamentos", icon: "mdi-router-network-wireless", route: "/equipamentos", path: "Equipment" },
      { name: "Ocorrências", icon: "mdi-account-eye-outline", route: "/ocorrencias", path: "Occurrence" },
      { name: "Comunicados", icon: "mdi-bullhorn-outline", route: "/comunicados", path: "Announcement" },
      { name: "Conversas", icon: "mdi-message-text-outline", route: "/conversas", path: "Chat" },
    ],
  },
  {
    name: "Operação",
    path: null,
    children: [
      { name: "Painel de saída", icon: "mdi-exit-run", route: "/painel-saida", path: "SchoolExit" },
      { name: "Configurações da escola", icon: "mdi-school-outline", route: "/configuracoes-escola", path: "SchoolSetting" },
    ],
  },
  {
    name: "Plataforma",
    path: "Platform",
    masterOnly: true,
    children: [
      { name: "Instituições", icon: "mdi-domain", route: "/tenants", path: "Tenant" },
    ],
  },
  {
    name: "Pedagógico",
    path: "Academic",
    children: [
      { name: "Matrículas", icon: "mdi-ballot-recount-outline", route: "/matriculas", path: "SchoolEnrollment" },
      { name: "Anos escolares", icon: "mdi-alarm-plus", route: "/anos-escolares", path: "SchoolYear" },
      { name: "Períodos Acadêmicos", icon: "mdi-animation-outline", route: "/periodos-academicos", path: "AcademicPeriod" },
      { name: "Ensinos", icon: "mdi-file-document-outline", route: "/ensinos", path: "Education" },
      { name: "Salas de Aula", icon: "mdi-google-classroom", route: "/salas-aula", path: "Classroom" },
      { name: "Turmas", icon: "mdi-account-group-outline", route: "/turmas", path: "Class" },
      { name: "Componentes curriculares", icon: "mdi-book-open-page-variant-outline", route: "/disciplinas", path: "Course" },
      { name: "Avaliações", icon: "mdi-clipboard-text-outline", route: "/avaliacoes", path: "Assessment" },
      { name: "Diário de Classe", icon: "mdi-calendar-check-outline", route: "/diario-classe", path: "Attendance" },
      { name: "Eventos", icon: "mdi-calendar-month-outline", route: "/eventos", path: "Calendar" },
    ],
  },
  
];

export default [...data];
